import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormGroup, FormControl } from "@angular/forms";

import { ShortCodeService } from "../../../../../../../../../../services/operator/shortcode.service";
import { ShortCode } from "../../../../../../../../../../utils/types/shared/shortcode.type";
import { RecordAction } from "../../../../../../../../../../utils/enums/shared/enums";
import { TranslateService } from "@ngx-translate/core";
import { Mask } from "../../../../../../../../../../utils/types/mask/mask.type";

@Component({
    selector: "wtf-shortcode-form",
    templateUrl: "./shortcode-form.component.html",
    styleUrls: ["./shortcode-form.component.scss"],
    providers: [ShortCodeService],
    encapsulation: ViewEncapsulation.None,
})
export class ShortCodeFormComponent implements OnInit {
    shortCodeModel: ShortCode = new ShortCode();
    dialogTitle: string;
    shortCodeForm: FormGroup;
    action: RecordAction;
    callback: (shortcode) => void;

    recordAction = RecordAction;

    isMaskEnable: boolean = false;

    maskList: Mask[] = [];

    typeOptions = [
        { name: "TX", value: "TX" },
        { name: "RX", value: "RX" },
        { name: "MASK", value: "MASK" },
        { name: "BOTH", value: "BOTH" },
    ];

    constructor(
        public dialogRef: MatDialogRef<ShortCodeFormComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private service: ShortCodeService,
        private _datasource: ShortCodeService,
        private translateService: TranslateService
    ) {
        this.action = data.action;
        this.callback = data.callback;

        if (
            this.action === RecordAction.Update ||
            this.action === RecordAction.View
        ) {
            this.shortCodeModel = data.short_code;
            this.dialogTitle = this.shortCodeModel.description;
        } else {
            this.dialogTitle = "Nuevo Short Code";
            this.dialogTitle = this.translateService.instant(this.dialogTitle);
        }

        this.shortCodeForm = this.createForm();
    }

    ngOnInit() {
        this.loadMasks();
    }

    private loadMasks() {
        this.service.getMask().subscribe((res: Mask[]) => {
            this.maskList = res;
        });
    }

    createForm() {
        const form = new FormGroup({
            value: new FormControl(this.shortCodeModel.value),
            type: new FormControl(this.shortCodeModel.type),
            mask: new FormControl(this.shortCodeModel.mask),
            description: new FormControl(this.shortCodeModel.description),
        });

        form.controls["value"].valueChanges.subscribe(
            (value) => (this.shortCodeModel.value = value)
        );
        form.controls["type"].valueChanges.subscribe(
            (value) => (this.shortCodeModel.type = value)
        );
        form.controls["mask"].valueChanges.subscribe(
            (value) => (this.shortCodeModel.mask = value)
        );
        form.controls["description"].valueChanges.subscribe(
            (value) => (this.shortCodeModel.description = value)
        );

        if (this.shortCodeModel.mask) {
            this.isMaskEnable = true;
        }

        return form;
    }

    getMask(value: string) {
        try {
            if (value === "MASK") {
                this.isMaskEnable = true;
                return;
            }

            this.isMaskEnable = false;
        } catch (error) {
            console.error(error);
        }
    }

    setMaskInDescription(value: string) {
        const actualDescription = this.shortCodeForm.get("description").value;
        let newDescription = this.generateDescription(actualDescription, value);

        this.shortCodeForm.get("description").setValue(newDescription);
    }

    private generateDescription(actualDescription: string, value: string) {
        if (actualDescription === null) {
            return value;
        }

        return actualDescription + " - " + value;
    }

    performAction() {
        if (this.shortCodeForm.invalid) {
            return;
        }
        this.callback(this.shortCodeModel);
    }
}
